/**
 * className 工具：clsx + tailwind-merge
 * 标准做法，跟 shadcn/ui 一致
 */
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
